import NProgress from 'nprogress';
import { gsap } from 'gsap';
//https://github.com/GoogleChromeLabs/quicklink
import { prefetch } from 'quicklink'; 

export default class {

    constructor(options) {

        // OPTIONS
        this.defaults = {
            $el  				: undefined,

            history 			: true,
            show_loading 		: true,
            transition_on		: 0.8,
            transition_off		: 0.47,

            trace_debug 		: false 
       }

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace  = 'ajax_view_control';

		// vars
		this.$el 		= this.options.$el;
		this.$body 		= $('body');
		this.active 	= false;
		this.href 		= false;
		this.view_id 	= false;
		this.$view 		= [];
		this.addHistory = true;

		// init!!!!
		this.init(true);
    }

	init( b ){

		this.log( 'INIT, b = ' + b );

		if( b ){
			this.view_id = this.$el.attr( 'data-view-id' );
			if ( !this.view_id ){
				this.log( 'data-view-id attribute is missing !' );
				return;
			}
			else{
				this.$view = $(document).find( '#' + this.view_id );
				if ( this.$view.length <= 0 ){
					this.log( 'View Page element with id ' + this.view_id + ' is missing !' );
					return;
				}
			}
			this.prefetch();
		}
		this.addEvents( b );
		this.initHistory( b );
		this.initLoading( b );

		this.active = b;
		// this.onResize();
	}

	prefetch(){
		if ( prefetch ){
			let urls = [];
			this.$el.find( 'a' ).each( (i,el) => {
				urls[i] = $(el).attr( 'href' );
			})
			if ( urls.length > 0 ){
				prefetch( urls );
			}
		}
	}

	
    addEvents( b ){

		if ( b ){
			this.$el.find( 'a' ).on( 'click', (e)=>this.onViewTrigger(e) );
		}
		else{
			this.$el.find( 'a' ).off( 'click', (e)=>this.onViewTrigger(e) );
		}

		//this.debounceResize(b);
    }

    onViewTrigger(e){
    	let $a = $(e.currentTarget);
    	e.preventDefault();
    	e.stopImmediatePropagation();

		if ($a.hasClass("reset-filters")) {
			$(".reset-filters").removeClass("filters-can-reset");
		} else {
			$(".reset-filters").addClass("filters-can-reset");
		}

    	if ( this.active ){
    		if ( document.location.href !== $a.attr( 'href' ) ){
	    		this.active = false;
	    		this.addHistory = true;
	    		this.loadView($a.attr("href"));
				
				$(".filters-exposed .active").removeClass("active");
				$a.closest("li").addClass("active");
				$a.closest(".filters").removeClass("filters-on");
    		}
    	}
    }

  	//--------------------------------------[ AJAX MANAGMENT ]-------------------------------------//
    loadView( href ){
    	this.href = href;
    	this.setLoading( true );
    	this.dimContent( true );

    	// AJAX CALL
		$.ajax({

		  	url: href,
		  	dataType: 'html',

			complete: ()=>{
				this.setLoading( false );
			},

			success: (data,status,xhr) => {   // success callback function
	        	
	    		//this.log( 'Ajax Success' );
	    		//this.log( data );
	    		this.addView( data );
	    	},

	    	error: (jqXhr, textStatus, errorMessage) => { // error callback 
	    		//this.log( 'Ajax Error: ' + errorMessage );
	    		document.location.href = this.href;

	       	}

		})
    }

    //--------------------------------------[ VIEW MANAGMENT ]-------------------------------------//
    dimContent( b, duration ){
    	if ( ! duration ){
    		duration = this.options.transition_off;
    	}
    	gsap.to( this.$view, {opacity:b?0.1:1, y:b?20:0,duration: duration } );
    	if ( b ){
    		this.enableContent( false );
    	}
    }

    enableContent(b){
    	this.$view.css({
    		'pointer-events' : b ? 'auto' : 'none'
    	})
    }

    addView( data ){
		let $view = $(data).find("#" + this.view_id),
			parser,
			doc,
			title;
		// if ($view.length <= 0) {
		// 	$view = $(data).filter("#" + this.view_id);
		// }
		// console.log($view);
		if ($view.length <= 0) {
			this.dimContent(false);
			return;
		}

		// insert view
		this.$view.height(this.$view.height());
		this.$view.html($view.html());
		gsap.killTweensOf(this.$view);
		gsap.fromTo(
			this.$view,
			{ opacity: 0, y: 20 },
			{
				opacity: 1,
				y: 0,
				duration: this.options.transition_on,
				onComplete: () => this.onAddView(),
			}
		);

		// get the page title
		parser = new DOMParser();
		doc = parser.parseFromString(data, "text/html");
		title = doc.title;
		parser = doc = null;

		// change page title
		this.changePageTitle(title);

		// add history
		this.addToHistory(this.href, title, false);
	}

    onAddView(){
		this.enableContent( true );
		this.$view.css({
			'height' : 'auto'
		});
		this.active = true;
    }

    //--------------------------------------[ HISTORY MANAGMENT ]-------------------------------------//
    initHistory(b){
    	if ( b ){
    		window.addEventListener('popstate', (event) => this.onPopStateHistory(event) );
    		// add the first page to History
    		this.addToHistory( document.location.href, $('title').text(), true );
    	}
    	else{
    		window.removeEventListener( 'postate', (event) => this.onPopStateHistory(event) )
    	}
    }

    onPopStateHistory(e){
    	//this.log( e );
    	//this.log( e.state );
    	if ( e.state ){
    		if ( e.state.namespace ){
    			if ( e.state.namespace === this.namespace ){
    				this.addHistory = false;
    				this.loadView( document.location.href )
    			}
    		}
    	}
    }

    addToHistory( url, title, replace=false ){
    	if ( this.options.history && window.history && this.addHistory ){
			const nextState = { namespace: this.namespace };
			// This will create a new entry in the browser's history, without reloading
			if ( replace ){
				window.history.replaceState( nextState, title, url );
			}
			else{
				window.history.pushState( nextState, title, url );
			}

    	}
    }


   //--------------------------------------[ UTILS ]-------------------------------------//
    changePageTitle( title ){
    	$('title').text( title );
    }

	initLoading(b){
		if ( ! this.options.show_loading ){
			return;
		}
		if ( NProgress ){
			if ( b ){
				NProgress.configure({ 
					trickleSpeed: 77 
				});
			}
		}
	}

	setLoading(b){
		if ( ! this.options.show_loading ){
			return;
		}
		if ( NProgress ){
			if ( b ){
				NProgress.start();
				this.$body.addClass( 'page-loading' );
			}
			else{
				NProgress.done();
				this.$body.removeClass( 'page-loading' );
			}
		}
	}

	log(args){
		if ( this.options.trace_debug ){
			console.log( 'TRACE DEBUG :: Namespace --> ' + this.namespace );
			console.log( args );
		}
	}

    destroy(){
		this.init( false );
    }

}

